import { render, staticRenderFns } from "./StrapiCataloguesView.vue?vue&type=template&id=4c0163d4"
import script from "./StrapiCataloguesView.vue?vue&type=script&lang=js"
export * from "./StrapiCataloguesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports